import React from "react";
import { Link } from "react-router-dom";
import {
  FaChalkboardTeacher,
  FaBuilding,
  FaWifi,
  FaHandPointer,
  FaDesktop,
  FaBrain,
} from "react-icons/fa";

import "./OneScreenPartner.css";

import Education from "../assets/onescreen1.png";
import Business from "../assets/onescreen2.png";

const solutions = [
  {
    title: "Education Solutions",
    image: Education,
    description:
      "Empower classrooms with interactive learning experiences using OneScreen TL7. Designed for collaborative education.",
    sizes: ["55\"", "65\"", "75\"", "86\""],
    features: [
      {
        icon: <FaChalkboardTeacher />,
        text: "Interactive Learning",
      },
      {
        icon: <FaHandPointer />,
        text: "40-Point Touch",
      },
      {
        icon: <FaWifi />,
        text: "Wireless Sharing",
      },
      {
        icon: <FaBrain />,
        text: "AI Powered",
      },
    ],
    link: "https://www.onescreensolutions.com/ae/product/touchscreen-tl7-education/",
  },

  {
    title: "Business Solutions",
    image: Business,
    description:
      "Transform boardrooms with powerful collaboration, wireless presentations, and AI-enhanced meetings for modern workplaces.",
    sizes: ["55\"", "65\"", "75\"", "86\""],
    features: [
      {
        icon: <FaBuilding />,
        text: "Meeting Rooms",
      },
      {
        icon: <FaDesktop />,
        text: "4K UHD Display",
      },
      {
        icon: <FaWifi />,
        text: "Wireless Sharing",
      },
      {
        icon: <FaBrain />,
        text: "AI Collaboration",
      },
    ],
    link: "https://www.onescreensolutions.com/ae/product/touchscreen-tl7-business/",
  },
];

const OneScreenPartner = () => {
  return (
    <section className="partner-section">

      <div className="partner-heading">

        <span>Technology Partner</span>

        <h2>OneScreen Interactive Display Solutions</h2>

        <p>
          Discover next-generation interactive displays designed for modern
          classrooms and collaborative business environments.
        </p>

      </div>

      <div className="partner-grid">

        {solutions.map((item, index) => (

          <div className="partner-card" key={index}>

            {/* Image */}

            <div className="partner-image">

              <img
                src={item.image}
                alt={item.title}
              />

            </div>

            {/* Content */}

            <div className="partner-content">

              <h3>{item.title}</h3>

              <p>{item.description}</p>

              {/* Features */}

              <div className="partner-features">

                {item.features.map((feature, i) => (

                  <div
                    className="feature-item"
                    key={i}
                  >
                    <span>{feature.icon}</span>

                    {feature.text}
                  </div>

                ))}

              </div>

              {/* Sizes */}

              <div className="partner-sizes">

                <h5>Available Sizes</h5>

                <div className="size-list">

                  {item.sizes.map((size, i) => (

                    <span key={i}>
                      {size}
                    </span>

                  ))}

                </div>

              </div>

              {/* Buttons */}

              <div className="partner-buttons">

                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="view-product-btn"
                >
                  View Product
                </a>

                <Link
                  to="/quote"
                  className="partner-quote-btn"
                >
                  Get Quote
                </Link>

              </div>

            </div>

          </div>

        ))}

      </div>

    </section>
  );
};

export default OneScreenPartner;